import * as React from 'react';

import Tooltip from 'components/Tooltip';
import StatusLabel from 'components/status-label/StatusLabel';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import ClientApprovalEntrySubtitle from '../client-approval-entry-subtitle/ClientApprovalEntrySubtitle';
import ClientApprovalEntryActions from '../client-approval-entry-actions/ClientApprovalEntryActions';

import { __t, applyTranslations } from 'utils/language';

import { ClientApprovalBucketV2, ClientApprovalStatus } from 'types';

import './client-approval-entry-caption.scss';

applyTranslations(require('./client-approval-entry-caption.i18n.json'));

type Props = {
  item: ClientApprovalBucketV2,
  onCaptionStatusChange: (status: ClientApprovalStatus) => void
};

const ClientApprovalEntryCaption: React.FC<Props> = (
  {
    item,
    onCaptionStatusChange
  }: Props
) => {
  const hasReviewedCaption = item.captionStatus && item.captionStatus !== 'pending';

  return (
    <React.Fragment>
      <ClientApprovalEntrySubtitle>
        {__t('client_approval_entry_caption.title')}
      </ClientApprovalEntrySubtitle>

      <VerticalSpacing type="small" />

      <div className="client-approval-entry-caption__container">
        <div className="client-approval-entry-caption__content">
          {item.caption}
        </div>

        {item.captionStatus === 'approved' && (
          <StatusLabel
            size="nano"
            type="success"
            label={__t('client_approval_entry_caption.status.approved')}
          />
        )}
        {item.captionStatus === 'declined' && (
          <StatusLabel
            size="nano"
            type="danger"
            label={__t('client_approval_entry_caption.status.declined')}
          />
        )}
        {hasReviewedCaption && (
          <Tooltip
            message={__t('client_approval_entry_caption.status_reset')}
            width="auto-compact"
            classNameWrapper="client-approval-entry-caption__reset-wrapper"
          >
            <SVGDynamicIcon
              name="rotate-left-custom-fg"
              width={16}
              height={14}
              customColor="grey"
              onClick={() => onCaptionStatusChange('pending')}
              clickable
            />
          </Tooltip>
        )}
        {!hasReviewedCaption && (
          <ClientApprovalEntryActions
            onApprove={() => onCaptionStatusChange('approved')}
            onDecline={() => onCaptionStatusChange('declined')}
          />
        )}
      </div>
    </React.Fragment>
  );
};
export default ClientApprovalEntryCaption;
